import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { pointsMock } from '../../mock';

import { styles } from './PointsSection.styles';

interface PointsSectionProps {
  onClickPrivate: () => void;
  onClickLoyalty: () => void;
  onClickLoyaltyProducts: () => void;
}

export function PointsSection({
  onClickPrivate,
  onClickLoyalty,
  onClickLoyaltyProducts
}: PointsSectionProps) {
  const slots = styles();
  const t = useTranslations('article.page.loyalty');
  const { points, description } = pointsMock(
    onClickPrivate,
    onClickLoyaltyProducts
  );

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <div>
          <h2 className={slots.title()}>{t('points.title')}</h2>
          <p className={slots.description()}>{description}</p>
        </div>
        <UiKitButtonBase
          color="primary"
          className={slots.headerButton()}
          onClick={onClickLoyalty}
        >
          {t('button')}
        </UiKitButtonBase>
      </div>
      <div className={slots.steps()}>
        {points.map((point) => {
          const isSoon = point.variant === 'soon';
          const href = point.href;

          const contentNode = (
            <>
              <div className={slots.stepIcon()}>
                <Image
                  src={point.icon}
                  alt={point.description}
                />
              </div>
              <div className={slots.stepDescription()}>
                {isSoon && (
                  <div className={slots.soonStepText()}>{t('points.soon')}</div>
                )}
                {point.description}
              </div>
              <div className={slots.stepArrow({ soon: isSoon })}>
                <ChevronIcon />
              </div>
            </>
          );

          if (href) {
            return (
              <Link
                key={point.description}
                className={slots.step()}
                href={href}
              >
                {contentNode}
              </Link>
            );
          }

          if (isSoon) {
            return (
              <div
                key={point.description}
                className={slots.step({ soon: isSoon })}
              >
                {contentNode}
              </div>
            );
          }

          return (
            <button
              type="button"
              key={point.description}
              className={slots.step({ soon: isSoon })}
              onClick={point.onClick}
            >
              {contentNode}
            </button>
          );
        })}
      </div>
      <UiKitButtonBase
        color="primary"
        className={slots.mobileButton()}
      >
        {t('button')}
      </UiKitButtonBase>
    </div>
  );
}
